"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _facebookLoginRenderProps = _interopRequireDefault(require("react-facebook-login/dist/facebook-login-render-props"));

var _baseModule = _interopRequireDefault(require("../styles/base.module.css"));

var _formFiledModule = _interopRequireDefault(require("../styles/form-filed.module.css"));

var _loginModule = _interopRequireDefault(require("../styles/login.module.css"));

var _Icons = require("./Icons");

var _constant = require("./constant");

var _signUpForm = _interopRequireDefault(require("./sign-up-form"));

var _facebookButton = _interopRequireDefault(require("./facebook-button"));

var _googleButton = _interopRequireDefault(require("./google-button"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var SignUp =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SignUp, _React$Component);

  function SignUp(props) {
    var _this;

    _classCallCheck(this, SignUp);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SignUp).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "forgotPass", function () {
      _this.setState(function (prev) {
        return {
          forgotPass: !prev.forgotPass
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "fbRes", function (res) {
      _this.socialResponse(res, "facebook");
    });

    _defineProperty(_assertThisInitialized(_this), "googleRes", function (res) {
      _this.socialResponse(res, "google");
    });

    _defineProperty(_assertThisInitialized(_this), "socialResponse", function (res, type) {
      var postData;

      if (type === "facebook" && res.email) {
        postData = {
          name: res.name,
          first_name: res.first_name,
          last_name: res.last_name,
          gender: res.gender,
          provider: type,
          email: res.email,
          provider_id: res.id,
          token: res.accessToken,
          provider_pic: res.picture.data.url
        };
      }

      if (type === 'google' && res) {
        postData = {
          name: res.name,
          first_name: res.given_name,
          last_name: res.family_name,
          provider: type,
          email: res.email,
          provider_id: res.sub,
          token: res.access_token,
          provider_pic: res.picture,
          gender: ''
        };
      }

      var jsonEncoded = JSON.stringify(postData);
      var formData = new FormData();
      formData.append("userData", jsonEncoded);

      _this.signUp(formData);
    });

    _defineProperty(_assertThisInitialized(_this), "signUp", function (formData) {
      var onSuccess = _this.props.onSuccess;
      fetch("".concat(_constant.API_ROOT, "signup.php"), {
        credentials: "same-origin",
        method: "POST",
        body: formData
      }).then(_constant.checkStatus).then(_constant.parseJSON).then(function (data) {
        if (data.status) {
          onSuccess(data.uid);
        }
      }).catch(function (err) {
        return console.log(err);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "signForm", function () {
      _this.setState(function (prev) {
        return {
          signForm: !prev.signForm
        };
      });
    });

    _this.state = {
      loading: false,
      error: false,
      signForm: false
    };
    return _this;
  }

  _createClass(SignUp, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          heading = _this$props.heading,
          onSuccess = _this$props.onSuccess;
      var signForm = this.state.signForm;
      return _react.default.createElement("div", {
        className: _baseModule.default.container
      }, signForm ? _react.default.createElement(_signUpForm.default, {
        back: this.signForm,
        onSuccess: onSuccess,
        login: this.props.login
      }) : _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("div", {
        className: _baseModule.default.heading2
      }, heading), _react.default.createElement("div", {
        className: _baseModule.default.container
      }, _react.default.createElement(_facebookLoginRenderProps.default, {
        appId: "1265085577412253",
        autoLoad: false,
        fields: "first_name,last_name,email,picture.type(large),gender",
        callback: this.fbRes,
        disableMobileRedirect: true,
        cookie: true,
        isDisabled: false,
        render: function render(renderProps) {
          return _react.default.createElement(_facebookButton.default, {
            type: "signup",
            onClick: renderProps.onClick,
            isProcessing: renderProps.isProcessing
          });
        }
      }), _react.default.createElement(_googleButton.default, {
        onFinished: this.googleRes,
        type: "signup"
      })), _react.default.createElement("div", {
        className: _loginModule.default.orContainer
      }, _react.default.createElement("span", null), _react.default.createElement("span", null, "or"), _react.default.createElement("span", null)), _react.default.createElement("div", {
        className: _loginModule.default.orContainer
      }, _react.default.createElement("button", {
        type: "submit",
        className: "".concat(_formFiledModule.default.button, " ").concat(_formFiledModule.default.primary, " ").concat(_formFiledModule.default.block, " ").concat(_baseModule.default.signUpWithEmail),
        onClick: this.signForm
      }, _react.default.createElement(_Icons.EmailIcon, {
        width: "1.25rem",
        color: "#fff"
      }), _react.default.createElement("span", null, "Sign up with email"))), _react.default.createElement("div", {
        className: _baseModule.default.container
      }, _react.default.createElement("div", {
        className: _baseModule.default.divider
      }), _react.default.createElement("p", {
        className: "".concat(_baseModule.default.small, " ").concat(_baseModule.default.light)
      }, "Already have an account with Trodly?", _react.default.createElement("span", {
        style: {
          marginLeft: "0.25rem"
        },
        className: "".concat(_baseModule.default.small, " ").concat(_baseModule.default.link, " ").concat(_baseModule.default.bold),
        onClick: this.props.login
      }, "Log in")))));
    }
  }]);

  return SignUp;
}(_react.default.Component);

SignUp.defaultProps = {
  heading: "Sign up"
};
SignUp.propTypes = {
  heading: _propTypes.default.string
};
var _default = SignUp;
exports.default = _default;